import { AxiosResponse } from "axios";
import { axiosConfigToUploadBase } from "../../config/api/configApiUploadFile";

type AuthSSOPayload = {
  response_type: string;
  client_id: string;
  redirect_uri: string;
  scope: string;
  state: string;
};

export const ssoAuthorize: (
  param: AuthSSOPayload
) => Promise<AxiosResponse<any>> = (param) => {
  return axiosConfigToUploadBase.post(`/v2/oauth2/authorize`, param);
};
